import Sidebar from "./Sidebar"
import LoginEmailCapture from '../auth/LoginEmailCapture.js'
import UnauthenticatedSidebarMenu from './UnauthenticatedSidebarMenu.js'

export default function UnauthenicatedLayout(props = {}) {
  return (
    <>
    <Sidebar menu={UnauthenticatedSidebarMenu}
    />
    <div className="content-wrapper">
      <section className="content body">
        <LoginEmailCapture />
      </section>
    </div>
    </>
  )
}